import {Action} from "redux";

import {
    GetCustomerByClientRequest,
    CreateScoutCustomerByClientRequest,
    CreateClientBookmarkByClientRequest,
    DeleteClientBookmarkByClientRequest,
    CopyHighlightsByClientRequest, DeleteHighlightsByClientRequest,
} from "../request/scout_request";

import {
    GetCustomerByClientResponse,
    CreateScoutCustomerByClientResponse,
    CreateClientBookmarkByClientResponse,
    DeleteClientBookmarkByClientResponse,
    CopyHighlightsByClientResponse, DeleteHighlightsByClientResponse,
} from "../response/scout_response";

export enum ClientScoutCustomerActionType {
    REQUEST_GET_CUSTOMER = "CLIENT_SCOUT_REQUEST_GET_CUSTOMER",
    CALLBACK_GET_CUSTOMER = "CLIENT_SCOUT_CALLBACK_GET_CUSTOMER",
    REQUEST_CREATE_SCOUT_CUSTOMER = "CLIENT_SCOUT_REQUEST_CREATE_CUSTOMER",
    CALLBACK_CREATE_SCOUT_CUSTOMER = "CLIENT_SCOUT_CALLBACK_CREATE_CUSTOMER",

    REQUEST_CREATE_CLIENT_BOOKMARK = "CLIENT_SCOUT_REQUEST_CREATE_CLIENT_BOOKMARK",
    CALLBACK_CREATE_CLIENT_BOOKMARK= "CLIENT_SCOUT_CALLBACK_CREATE_CLIENT_BOOKMARK",
    REQUEST_DELETE_CLIENT_BOOKMARK = "CLIENT_SCOUT_REQUEST_DELETE_CLIENT_BOOKMARK",
    CALLBACK_DELETE_CLIENT_BOOKMARK= "CLIENT_SCOUT_CALLBACK_DELETE_CLIENT_BOOKMARK",

    REQUEST_COPY_HIGHLIGHTS = "CLIENT_SCOUT_REQUEST_COPY_HIGHLIGHTS",
    CALLBACK_COPY_HIGHLIGHTS = "CLIENT_SCOUT_CALLBACK_COPY_HIGHLIGHTS",
    REQUEST_DELETE_HIGHLIGHTS = "CLIENT_SCOUT_REQUEST_DELETE_HIGHLIGHTS",
    CALLBACK_DELETE_HIGHLIGHTS = "CLIENT_SCOUT_CALLBACK_DELETE_HIGHLIGHTS",
}

export interface IRequestGetCustomerAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_GET_CUSTOMER;
    item: GetCustomerByClientRequest;
}

export interface ICallbackGetCustomerAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_GET_CUSTOMER;
    isSuccess: boolean;
    item?: GetCustomerByClientResponse;
    error?: any;
}

export interface IRequestCreateScoutCustomerAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_CREATE_SCOUT_CUSTOMER;
    item: CreateScoutCustomerByClientRequest;
}

export interface ICallbackCreateScoutCustomerAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_CREATE_SCOUT_CUSTOMER;
    isSuccess: boolean;
    item?: CreateScoutCustomerByClientResponse;
    error?: any;
}

export interface IRequestCreateClientBookmarkAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_CREATE_CLIENT_BOOKMARK;
    item: CreateClientBookmarkByClientRequest;
}

export interface ICallbackCreateClientBookmarkAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_CREATE_CLIENT_BOOKMARK;
    isSuccess: boolean;
    item?: CreateClientBookmarkByClientResponse;
    error?: any;
}

export interface IRequestDeleteClientBookmarkAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_DELETE_CLIENT_BOOKMARK;
    item: DeleteClientBookmarkByClientRequest;
}

export interface ICallbackDeleteClientBookmarkAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_DELETE_CLIENT_BOOKMARK;
    isSuccess: boolean;
    item?: DeleteClientBookmarkByClientResponse;
    error?: any;
}

export interface IRequestCopyHighlightsAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_COPY_HIGHLIGHTS;
    item: CopyHighlightsByClientRequest;
}

export interface ICallbackCopyHighlightsAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_COPY_HIGHLIGHTS;
    isSuccess: boolean;
    item?: CopyHighlightsByClientResponse;
    error?: any;
}

export interface IRequestDeleteHighlightsAction extends Action {
    type: ClientScoutCustomerActionType.REQUEST_DELETE_HIGHLIGHTS;
    item: DeleteHighlightsByClientRequest;
}

export interface ICallbackDeleteHighlightsAction extends Action {
    type: ClientScoutCustomerActionType.CALLBACK_DELETE_HIGHLIGHTS;
    isSuccess: boolean;
    item?: DeleteHighlightsByClientResponse;
    error?: any;
}

export type ClientScoutCustomerAction =
    IRequestGetCustomerAction |
    ICallbackGetCustomerAction |
    IRequestCreateScoutCustomerAction |
    ICallbackCreateScoutCustomerAction |
    IRequestCreateClientBookmarkAction |
    ICallbackCreateClientBookmarkAction |
    IRequestDeleteClientBookmarkAction |
    ICallbackDeleteClientBookmarkAction |
    IRequestCopyHighlightsAction |
    ICallbackCopyHighlightsAction |
    IRequestDeleteHighlightsAction |
    ICallbackDeleteHighlightsAction
    ;

export interface IClientScoutCustomerActionCreator {

    requestGetCustomerAction(item: GetCustomerByClientRequest): IRequestGetCustomerAction;

    callbackGetCustomerAction(
        isSuccess: boolean,
        items?: GetCustomerByClientResponse,
        error?: any,
    ): ICallbackGetCustomerAction;

    requestCreateScoutCustomerAction(item: CreateScoutCustomerByClientRequest): IRequestCreateScoutCustomerAction;

    callbackCreateScoutCustomerAction(
        isSuccess: boolean,
        items?: CreateScoutCustomerByClientResponse,
        error?: any,
    ): ICallbackCreateScoutCustomerAction;

    requestCreateClientBookmarkAction(item: CreateClientBookmarkByClientRequest): IRequestCreateClientBookmarkAction;

    callbackCreateClientBookmarkAction(
        isSuccess: boolean,
        items?: CreateClientBookmarkByClientResponse,
        error?: any,
    ): ICallbackCreateClientBookmarkAction;

    requestDeleteClientBookmarkAction(item: DeleteClientBookmarkByClientRequest): IRequestDeleteClientBookmarkAction;

    callbackDeleteClientBookmarkAction(
        isSuccess: boolean,
        items?: DeleteClientBookmarkByClientResponse,
        error?: any,
    ): ICallbackDeleteClientBookmarkAction;

    requestCopyHighlightsAction(item: CopyHighlightsByClientRequest): IRequestCopyHighlightsAction;

    callbackCopyHighlightsAction(
        isSuccess: boolean,
        items?: CopyHighlightsByClientResponse,
        error?: any,
    ): ICallbackCopyHighlightsAction;

    requestDeleteHighlightsAction(item: DeleteHighlightsByClientRequest): IRequestDeleteHighlightsAction;

    callbackDeleteHighlightsAction(
        isSuccess: boolean,
        items?: DeleteHighlightsByClientResponse,
        error?: any,
    ): ICallbackDeleteHighlightsAction;
}

class ActionCreator implements IClientScoutCustomerActionCreator {

    public requestGetCustomerAction = (item: GetCustomerByClientRequest): IRequestGetCustomerAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_GET_CUSTOMER,
            item,
        };
    };

    public callbackGetCustomerAction = (
        isSuccess: boolean,
        item?: GetCustomerByClientResponse,
        error?: any,
    ): ICallbackGetCustomerAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_GET_CUSTOMER,
            isSuccess,
            item,
            error,
        };
    };

    public requestCreateScoutCustomerAction = (item: CreateScoutCustomerByClientRequest): IRequestCreateScoutCustomerAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_CREATE_SCOUT_CUSTOMER,
            item,
        };
    };

    public callbackCreateScoutCustomerAction = (
        isSuccess: boolean,
        item?: CreateScoutCustomerByClientResponse,
        error?: any,
    ): ICallbackCreateScoutCustomerAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_CREATE_SCOUT_CUSTOMER,
            isSuccess,
            item,
            error,
        };
    };

    public requestCreateClientBookmarkAction = (item: CreateClientBookmarkByClientRequest): IRequestCreateClientBookmarkAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_CREATE_CLIENT_BOOKMARK,
            item,
        };
    };

    public callbackCreateClientBookmarkAction = (
        isSuccess: boolean,
        item?: CreateClientBookmarkByClientResponse,
        error?: any,
    ): ICallbackCreateClientBookmarkAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_CREATE_CLIENT_BOOKMARK,
            isSuccess,
            item,
            error,
        };
    };

    public requestDeleteClientBookmarkAction = (item: DeleteClientBookmarkByClientRequest): IRequestDeleteClientBookmarkAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_DELETE_CLIENT_BOOKMARK,
            item,
        };
    };

    public callbackDeleteClientBookmarkAction = (
        isSuccess: boolean,
        item?: DeleteClientBookmarkByClientResponse,
        error?: any,
    ): ICallbackDeleteClientBookmarkAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_DELETE_CLIENT_BOOKMARK,
            isSuccess,
            item,
            error,
        };
    };

    public requestCopyHighlightsAction = (item: CopyHighlightsByClientRequest): IRequestCopyHighlightsAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_COPY_HIGHLIGHTS,
            item,
        };
    };

    public callbackCopyHighlightsAction = (
        isSuccess: boolean,
        item?: CopyHighlightsByClientResponse,
        error?: any,
    ): ICallbackCopyHighlightsAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_COPY_HIGHLIGHTS,
            isSuccess,
            item,
            error,
        };
    };

    public requestDeleteHighlightsAction = (item: DeleteHighlightsByClientRequest): IRequestDeleteHighlightsAction => {
        return {
            type: ClientScoutCustomerActionType.REQUEST_DELETE_HIGHLIGHTS,
            item,
        };
    };

    public callbackDeleteHighlightsAction = (
        isSuccess: boolean,
        item?: DeleteHighlightsByClientResponse,
        error?: any,
    ): ICallbackDeleteHighlightsAction => {
        return {
            type: ClientScoutCustomerActionType.CALLBACK_DELETE_HIGHLIGHTS,
            isSuccess,
            item,
            error,
        };
    };
}

export const createClientScoutCustomerActionCreator = (): IClientScoutCustomerActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_scout_customer_action.ts